@if (isPageLoading) {
  <ngx-navigation-animation />
}
<main [@fadeAnimation]="getRouterOutletState(o)">
  <router-outlet #o="outlet"></router-outlet>
</main>